import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import 'react-toastify/dist/ReactToastify.css';

import { renderToString } from 'react-dom/server';
import { SharingPopup, APIHandler } from 'C4';

import Countdown from 'react-countdown';
import whiteLogo from 'assets/images/logo/logo.png';
import virtualLogo from 'assets/images/logo/logo_virtual.png';
import logo from 'assets/images/logo/logoXpoPRO.png';
import darklogo from 'assets/images/logo/logo_white.png';
import sponsorLogo from 'assets/images/logo/logo_sponsors.png';

import moment from 'moment-timezone';
import SweetAlert from 'sweetalert-react';

const Completionist = () => <span>00:00:00:00</span>;

export default class CountDownView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      time: Date.now(),
      date: new Date('2022-01-21T14:00:00.000-05:00'),
      timezone: '',
      userCountry: 'US',
    };
  }

  componentDidMount() {
    APIHandler.getLocation().then((location) => {
      this.setState({ userCountry: 'US' });
      if (location) {
        this.setState({ userCountry: location.countryCode });
      }
    });
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  componentWillMount() {
    const zone = moment.tz.guess();
    const abbr = moment.tz(zone).format('z');
    this.setState({ timezone: abbr });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { date, timezone, userCountry, time } = this.state;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['share', 'close'],
      share: {
        tpl: renderToString(
          <SharingPopup url="https://front.travpromobile.com/848/ProgramGuide.pdf" />,
        ),
      },
    };

    let registerSuccessful = localStorage.getItem('registerSuccessful');

    return (
      <div className="countDownView">
        <div className="gradient" />
        <div className="bg" />
        <div className="hidden">{time}</div>

        <SweetAlert
          title=""
          show={userCountry !== 'CA' && userCountry !== 'US' && userCountry !== 'NL'}
          text="This show is currently not available in your region."
          type="warning"
          html
          customClass="warningMessage"
          showConfirmButton={false}
          cancelButtonText="Return &gt;"
          showCancelButton={false}
          onConfirm={() => {
            this.setState({ userCountry: 'US', redirect: '/main' });
          }}
          onEscapeKey={() => {
            this.setState({ userCountry: 'US', redirect: '/main' });
          }}
          onCancel={() => {
            this.setState({ userCountry: 'US', redirect: '/main' });
          }}
        />

        <div className="countDownHolder">
          <React.Fragment>
            <h1>
              <img src={virtualLogo} alt="virtuallogo" className="virtuallogo" />
              <br />
              <div className="dateHeader">
                <span>January 21 – 23, 2022</span>
              </div>

              <p>Friday, 1/21 - 2 p.m. – 6 p.m.</p>
              <p>Saturday, 1/22 – 9 a.m. – 5 p.m. </p>
              <p>Sunday, 1/23 – 10 a.m. – 3 p.m.</p>

            </h1>
            <hr />
            <p>
                <h2>Let’s go!</h2>
                <h2>The world is calling.</h2>
                <br />
                Welcome to AAA Travel Virtual Marketplace! This <b>FREE</b> event will feature unbeatable travel deals, limited time offers and exclusive member benefits. Plus, learn about dream-worthy destinations and chat with our industry experts. 
                <br /><br />
                That’s not all! AAA Travel advisors will be available to ask questions, learn about travel options and help you plan an unforgettable vacation. 
                <br /><br />
                So, join us and together we can find authentic experiences, customizable vacations and sought-after moments that take your breath away.         
                <br />
            </p>

            {new Date(date) < Date.now() && (
              <React.Fragment>
                <a href="https://www.aaanortheastmarketplace.com/login">
                  <button className="continue">Open now! Continue to login</button>
                </a>
              </React.Fragment>
            )}

            <Link to="/attendee">
              {registerSuccessful ? (
                <button className="register" id="preregister" disabled>
                  You have been successfully registered!
                </button>
              ) : (
                <button className="register" id="preregister">
                  Register Today!
                </button>
              )}
            </Link>

            <div className="countDown">
              <span className="showstart"> The show will start in:</span>
              <Countdown date={date}>
                <Completionist />
              </Countdown>
              <div className="date">
                <span>DAYS</span>
                <span>HOURS</span>
                <span>MINUTES</span>
                <span>SECONDS</span>
              </div>
            </div>

            <div className="actionButtons__Holder" id="bottom-buttons">
              <a className="continue" href="https://front.travpromobile.com/848/aaa.ics">
                Add to Calendar <br /> (ICS)
              </a>
            </div>
            <div className="sponsors_countdown">
              <img src="https://front.travpromobile.com/770/Sponsor Logo Wall.png" alt="logo" />
            </div>
          </React.Fragment>

          <div className="powered">
            <text>Powered by</text>
            <img src={`/${darklogo}`} className="logo__bottom" alt="logo" />
          </div>
        </div>
      </div>
    );
  }
}
